import {format, getDaysInMonth} from 'date-fns'

export default function () {
  return {
    apiBaseUrl: process.env.VUE_APP_API_URL,
    filters: {
      company: null,
      'month[after]': format(new Date().setDate(1), 'yyyy-MM-dd'),
      'month[before]': format(new Date().setDate(getDaysInMonth(new Date())), 'yyyy-MM-dd'),
      'createdAt[after]': null,
      'createdAt[before]': null,
    },
  }
}
